import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsUp32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconThumbsUp32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 15H8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1zm2 10h10.362a2 2 0 0 0 1.839-1.212l2.571-6A2 2 0 0 0 23.934 15h-6.688l.268-2.238.733-6.106-6.746 7.665-.501.57zm9.233-18.106L19.74 11l-.24 2h4.434c2.871 0 4.808 2.936 3.676 5.576l-2.571 6A4 4 0 0 1 21.362 27H8a4 4 0 0 1-4-4v-6a4 4 0 0 1 4-4h2l6.746-7.665c1.297-1.475 3.72-.39 3.487 1.56"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsUp32);
